export default {

    vulnerabilities: 'Vulnerabilities',
    vulnerabilitiesMenu: 'vulnerability catalog',
    vulnerability: 'Vulnerability',
    vulnerabilitiesOfAsset: 'Vulnerabilities of asset',
    newVulnerability: 'New Vulnerability',
    getVulnerabilitysError: 'An error occurred while fetching vulnerabilities',
    deleteVulnerabilityError: 'An error occurred while deleting the vulnerability',
    deleteVulnerabilitySuccess: 'Vulnerability successfully deleted',
    severity: 'Severity',
    noSeverity: 'Severity not found',
    noSeverities: 'Severities not found',
    editVulnerabilityError: 'An error occurred while editing the vulnerability',
    createVulnerabilityError: 'An error occurred while creating the vulnerability',
    editVulnerabilitySuccess: 'Vulnerability successfully updated',
    createVulnerabilitySuccess: 'Vulnerability successfully created',
    createVulnerability: 'Create Vulnerability',
    createLoaderVulnerability: 'Creating Vulnerability',
    editLoaderVulnerability: 'Editing Vulnerability',
    deleteLoaderVulnerability: 'Deleting Vulnerability',
    editVulnerability: 'Edit Vulnerability',
    noRegisteredVulnerabilities: 'You do not have any registered vulnerabilities yet',
    importVulnerabilitiesFromExcel: 'You can import vulnerabilities from a excel file.',
    vulnerabilitiesGuide: 'The following is an inventory of vulnerabilities that can be exploited by threats to affect system assets. You can add new ones, edit them or associate them with the corresponding assets and threats.',
    catalogVulnerabilities: 'Vulnerabilities Catalog',
    saveVulnerability: 'Save vulnerability',
    vulnerabilitiesGuideSettings: 'Manage the vulnerability catalog and import new records to keep it up to date.',

};
